<template>
  <!-- Site wrapper -->
  <div>
    <!-- Main content -->
    <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
      <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
      <b-spinner class="ml-2" variant="danger"></b-spinner>
    </div>
    <form class="forms-sample">
      <div class="row justify-content-between">
        <!-- Coluna Upload Avatar -->
        <slot name="upload-avatar">
          <div class="col-md-3 col-sm-12 col-xs-12 col-xl-3 col-lg-3">
            <UploadAvatar
              @input="receberDadosUploadAvatar"
              uploadFileRef="avatarMeuCadastro"
              :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
              :codigoFotoUsuario="fotoUsuario"
            />
            <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros['f_photo.*']}}</div>
          </div>
        </slot>

        <!-- Coluna do Formulário (campos) -->
        <div class="col-md-8 col-sm-12 col-xs-12 col-xl-8 col-lg-8">
          <div class="row">
            <slot name="nome-completo">
              <!-- Nome Completo -->
              <div class="col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                <div class="form-group">
                  <label for="inputNomeCompleto" class="required">Nome Completo</label>
                  <input type="text" v-model="formulario.f_name" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputNomeCompleto">
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_name}}</div>
                </div>
              </div>
            </slot>
            <slot name="data-nascimento">
              <!-- Data Nascimento -->
              <div class="col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                <div class="form-group">
                  <label for="inputDataNascimento" class="required">Data Nascimento</label>
                  <Datefield v-model="formulario.f_birthday" :classField="'form-control'" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" :id="'inputDataNascimento'"/>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_birthday}}</div>
                </div>
              </div>
            </slot>

            <slot name="unidade">
              <!-- Unidade -->
              <div class="col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                <div class="form-group">
                  <label for="inputUnidade" class="required">Equipe</label>
                  <v-select
                    class="comboFonteDefault style-chooser"
                    v-model="formulario.f_office"
                    :options="comboUnidadesDisponiveis"
                    @search="eventoDigitarBuscaPorUnidade"
                    :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                    :filterable="false"
                  >
                    <template v-slot:no-options>
                      <em>Nenhum registro encontrado.</em>
                    </template>
                  </v-select>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_office}}</div>
                </div>
              </div>
            </slot>

            <slot name="estado">
              <!-- Estado -->
              <div class="col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                <div class="form-group">
                  <label for="inputSede" class="required">Estado</label>
                  <b-form-select
                    v-model="formulario.f_sede"
                    :options="comboEstados"
                    value-field="id"
                    text-field="nome"
                    :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                    class="form-control comboFonteDefault"
                    id="inputSede"
                  />
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_sede}}</div>
                </div>
              </div>
            </slot>

            <slot name="telefone">
              <!-- Telefone -->
              <div class="col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                <div class="form-group">
                  <label>Telefone</label>
                  <TelefoneInput v-model="formulario.f_extension" class="form-control" :mask="mascaraTelefoneCelular(formulario.f_extension)" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"/>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_extension}}</div>
                </div>
              </div>
            </slot>

            <slot name="email">
              <!-- E-mail -->
              <div class="col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                <div class="form-group">
                  <label for="inputEmail" class="required">E-mail</label>
                  <input type="email" v-model="formulario.f_email" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputEmail" placeholder="email@example.com">
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_email}}</div>
                </div>
              </div>
            </slot>

            <slot name="usuario">
              <!-- Usuário -->
              <div class="col-md-6 col-sm-12 col-xs-12 col-xl-6 col-lg-6">
                <div class="form-group">
                  <label for="inputUsuario" class="required">Usuário</label>
                  <input type="text" v-model="formulario.f_username" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" class="form-control" id="inputUsuario">
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_username}}</div>
                </div>
              </div>
            </slot>

            <slot name="senha">
            </slot>

            <slot name="confirmacao-senha">
            </slot>

            <slot name="campos-adicionais"></slot>

            <slot name="horario-inicio">
              <div class="col-auto">
                <label for="inputHoraInicio" class="required">Hora de Início</label>
                <div class="form-group">
                  <Timefield v-model="formulario.f_hour_begin" :classField="'form-control'" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" />
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_hour_begin}}</div>
                </div>
              </div>
            </slot>
            <slot name="hora-encerramento">
              <div class="col-auto">
                <label for="inputHoraEncerramento" class="required">Hora de Encerramento</label>
                <div class="form-group">
                  <Timefield v-model="formulario.f_hour_end" :classField="'form-control'" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" />
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_hour_end}}</div>
                </div>
              </div>
            </slot>

            <slot name="dias-da-semana">
              <div class="col-12">
                <div class="form-group">
                  <label for="inputDiasSemana" class="required">Dias da Semana</label>
                  <b-form-checkbox-group
                    v-model="formulario.f_daysweek"
                    :options="diasSemanaOptions"
                    :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status"
                    value-field="valor" text-field="label"
                    class="diasDaSemana">
                  </b-form-checkbox-group>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_daysweek}}</div>
                </div>
              </div>
            </slot>

            <slot name="status">
              <!-- Status -->
              <div v-if="formulario.f_id !== null" class="col-6">
                <div class="form-group">
                  <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success mb-2">
                    <input type="checkbox" v-model="formulario.f_status" class="custom-control-input" id="customSwitchStatus" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">
                    <label class="custom-control-label" for="customSwitchStatus">Ativo</label>
                  </div>
                  <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.f_status}}</div>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>

      <!-- Loader -->
      <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
        <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
        <b-spinner class="ml-2" variant="danger"></b-spinner>
      </div>
    </form>
  </div><!-- ./wrapper -->
</template>

<script>
import Informacoes from './js/informacoes'
export default Informacoes
</script>

<style scoped>
@import "./scss/usuarios.scss";
</style>
